export const kuInfo = `
Introduction:
I'm your friendly Kindness Unlimited (KU) chatbot, here to assist you with anything you need related to our organization! Whether you're looking for information about our volunteering opportunities, ongoing projects, or how to donate, I'm here to help.

Organization Details:
Kindness Unlimited (KU) is a youth-centric, volunteer-led organization established in Mumbai, India, on July 1, 2005. We are dedicated to promoting social and economic change through the power of kindness. We are proud to be the peak national body in India representing the World Kindness Movement, and the only Indian organization on its executive committee. Our founder trustee is Ms. Nirmala Mehendale.

Mission & Vision:
Our core philosophy defines kindness as "Balancing self-interest with the Common Good." 
Our mission is to transform mindsets to encourage more sharing of time, resources, skills, knowledge, and money, and to celebrate the up-standers in society. 
Our vision is a society where socio-economic progress is deeply rooted in collective empathy and compassion for humanity, closely aligning with UN Sustainable Development Goals (SDGs).

How to Join & Volunteer:
Ready to make a difference? Joining Kindness Unlimited is simple and rewarding! 
1. Go to our website and Log In.
2. Fill in your personal details to complete your profile.
3. Browse and join various volunteering activities organized by KU.
4. Complete activities to earn special rewards and make an impact in your community!

The Kindness Jam:
The Kindness Jam is our flagship annual event organized to celebrate World Kindness Day through music, laughter, and generosity. It features a unique "pay-it-forward" concept—entry isn't about cash; it's about kindness! Volunteers earn their tickets to this incredible evening of entertainment (featuring famous stand-up comedians, musicians, and artists who perform purely out of goodwill) by dedicating their time and hours of service to various NGO activities like beach clean-ups, tree planting, and teaching. 

Key Projects:
- Project Nashta: Addresses the critical nutrition needs of underprivileged children from Adivasi areas and the urban poor by providing culturally contextual nutritional meals (like bananas).
- Plant Kindness: An environmental and sustainable livelihood initiative. We work with the Kathkari tribe in Maharashtra to plant fruit trees (e.g., 40,000 trees), ensuring sustainable nutrition and additional income.
- Project KUL (Kindness Unlimited Learning): A youth-focused project operating in educational institutions. Students commit to 30 hours of volunteering, followed by deep reflection sessions to internalize kindness as a life skill.
- Kindness Carnival (Daan Utsav): A platform designed for schools and youth to celebrate India's Festival of Giving through stalls, events, and awareness initiatives.

Our Impact:
Over the last two decades, Kindness Unlimited has mobilized a vast network of individuals. We have engaged over 220,000 Givers, reached 5,600,000+ Receivers, and inspired more than 8,200,000 Observers.

Location & Contact Information:
Our registered office is located at A-102 Ajanta, Sant Muktabai Road, Vile Parle (East), Mumbai 400057, Maharashtra, India.
To get in touch, email us at contactus@kindnessunlimited.in or call us at +91 9820710081.

Social Media:
- Instagram: https://www.instagram.com/kindnessunlimited
- Facebook: https://www.facebook.com/KindnessUnlimited.in
- LinkedIn: https://www.linkedin.com/company/kindness-unlimited
- YouTube: https://www.youtube.com/user/KindnessUnlimited

Donations:
KU is a Registered Trust, GuideStar Certified, and 80G Tax Exemption Applicable. 
You can support our cause by donating to our bank account: SB A/c 3736000107003253.

Quick Links for More Information:
- Official Website: https://kindnessunlimited.in
- Volunteer Login / Sign Up: https://kindnessunlimited.in/volunteering
- Events & The Kindness Jam: https://kindnessunlimited.in/engagements
- Donate directly: https://kindnessunlimited.in/donate
- Instagram: https://www.instagram.com/kindnessunlimited
- Facebook: https://www.facebook.com/KindnessUnlimited.in
- LinkedIn: https://www.linkedin.com/company/kindness-unlimited
- YouTube: https://www.youtube.com/user/KindnessUnlimited
`;
